<div class="container container-fluid">
    <div class="text-left content">
        <h2 style="text-align: center">Here's what's next</h2>
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="col-md-3 mb-3">
                    <img src="assets/img/lgicon_call.svg" class="img-responsive center-block img-thankyou" />
                    <p style="text-align: center;"><b>Complete your application</b><br />A licensed eFinancial agent
                        will contact you to finalize all other details and review your coverages with you.</p>                   
                </div>

                <div class="col-md-3 mb-3">
                    <img src="assets/img/lgicon_medexam.svg" class="img-responsive center-block img-thankyou" />
                    <p style="text-align: center;"><b>You may need a medical exam</b><br />If the life insurance
                        company
                        you chose requires it, it will be free and we can help you schedule it at your convenience.
                    </p>                    
                </div>

                <div class="col-md-3 mb-3">
                    <img src="assets/img/icon_mail.svg" class="img-responsive center-block img-thankyou" />
                    <p style="text-align: center;"><b>Your company reviews your info</b><br />If you don’t need a
                        medical exam, it may take 24-48 hours to review your application. In other cases, it may
                        take
                        2-8 weeks. Then, your company will mail your documents and final rates.</p>
                </div>
            </div>
        </div>
    </div>
</div>